import { createContext } from "react";

/**
 * Контекст с перечнем населенных пунктов
 */
const CityListContext = createContext([]);
export default CityListContext;
